import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { usePendingInviteCount } from '@features/user/invitations/hooks/usePendingInviteCount';

const PendingInvitationsBanner: React.FC = () => {
  const navigate = useNavigate();
  const { total, hasLoaded } = usePendingInviteCount();

  if (!hasLoaded || total === 0) {
    return null;
  }

  const label = total === 1 ? 'invitation' : 'invitations';

  return (
    <Alert variant="info" className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-0">
      <span className="mb-0">
        You have {total} pending {label}.
      </span>
      <Button
        variant="outline-info"
        size="sm"
        onClick={() => navigate('/pending-invitations')}
      >
        Review invitations
      </Button>
    </Alert>
  );
};

export default PendingInvitationsBanner;
